import React from 'react';
import parse from 'html-react-parser';

function Address({ data, handleAddressSelect, editPopup, setEditPopup }) {
  return (
    <div className="bodyLeftRow">
      <div
        className="bodyLeftRowData cursor"
        onClick={() => handleAddressSelect(data)}
      >
        <span className="left width100 name">{data.nameLabel}</span>
        <span className="left width100 Address">{data.addressLabel}</span>
        <span className="left width100 email">
          &#9993;&nbsp;&nbsp;{data.email}
        </span>
        <span className="left width100 conctact">
          {`${
            data.phone_l
              ? parse('&#128222;&nbsp;Desk: ') + data.phone_l + ' | '
              : ''
          } `}
          {`${
            data.phone_m
              ? parse('&#128385;&nbsp;Cell: ') + data.phone_m + ' | '
              : ''
          } `}
          {`${data.fax ? parse('Fax: ') + data.fax : ''} `}
          {`${data.npi_no ? parse(' | NPI: ') + data.npi_no : ''} `}
        </span>
      </div>
      <div
        className="bodyLeftRowAction"
        onClick={() => setEditPopup({ open: true, referringMasterId: data.id })}
      >
        &#9998;
      </div>
    </div>
  );
}

export default Address;
